import {supportNative, getErrorFactory, logError} from './util';
import Detector from '../utils/detector';
import nativeEvent from './event';
import { show as showH5Picker } from '../components/H5Picker';

//降级兼容
const isApp = Detector.browser.tantutravel;
let version = Detector.browser.fullVersion.split('.');
// const useH5Picker = isApp && (version[0] <= 1 && version[1] <= 1);
// 由于base_showPicker只有探途旅行支持，所以统一由前端实现
const useH5Picker = true;

const zzc = window.zzc;

/**
 * 显示选择列表
 * 参数如下
 * list:[{
      'text' : '110', 
      'subList':[{'text':'120'}, {'text':'121'}, {'text':'122'}]
    }, 
    {
      'text' : '210', 
      'subList':[{'text':'220'}, {'text':'221'}, {'text':'222'}]
    }], 
    activeIndexs:[1, 0],
    handleConfirm: function(){
      
    }
 */
export default function showPicker(options) {
  if(useH5Picker){
    showH5Picker(options);
  }else{
    let errorFactory = getErrorFactory('base_showPicker');
    if (!supportNative('base_showPicker')) {
      return logError(errorFactory('不支持zzcjsbridge'));
    }
    zzc.call('base_showPicker', options);
    nativeEvent.on('picker-did-confrim-click', function (data){
      options.handleConfirm && options.handleConfirm(data.activeIndexs); 
    });
  }
 
}



// WEBPACK FOOTER //
// ./src/native/showPicker.js